import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { BlocklyWorkspace } from "react-blockly";

import { blockly, HU, Blockly } from '@app/config/blockly';
import { Button } from '@app/core/Elements/Button';
import { SendCommand } from '@app/core/Elements/Unity';
import { selectBlocks, selectStage } from "@app/store/selectors/data.selectors";

const initialXml = `<xml xmlns="http://www.w3.org/1999/xhtml"></xml>`;
const initialToolbox = {
  "kind": "flyoutToolbox",
  "contents": []
};

interface Props
{
}
export const Blocks: React.FC<Props> = () =>
{
  const [xml, setXml] = useState(initialXml);
  const [code, setCode] = useState("");
  const [count, setCount] = useState(0);

  const [initial, setInitial] = useState(initialXml);
  const [toolbox, setToolbox] = useState(initialToolbox);
  const [showFinish, setShowFinish] = useState(false);

  const blocks = useSelector(selectBlocks);
  const stage = useSelector(selectStage);

  useEffect(() =>
  {
    if (!blocks?.initial || !blocks.playable)
      return;

    blockly.setLocale(HU);
    blockly.mainWorkspace.addChangeListener(Blockly.Events.disableOrphans);

    let xml = blockly.Xml.textToDom(blocks.initial);
    blockly.Xml.clearWorkspaceAndLoadFromXml(xml, blockly.mainWorkspace);

    setInitial(blocks.initial);
    setToolbox(JSON.parse(blocks.playable));

  }, [blocks]);

  useEffect(() =>
  {
    if (stage == null) return;
    if (stage.docId.indexOf("rocket") !== -1)
      setShowFinish(false);
    else
      setShowFinish(true);
  }, [stage]);

  const onChange = async (data) =>
  {
    setCode(blockly.Lua.workspaceToCode(data));
    setCount(blockly.mainWorkspace.getAllBlocks().length);
  }

  /*
  useEffect(() =>
  {
    console.log(xml);
    console.log("XX", blockly.mainWorkspace.getAllBlocks().length);
  }, [xml]);
  */

  const onRun = () =>
  {
    var res = `player.setBlocks(${count}) \n player.setFinish(false) \n ${code} \n player.RunEvents()`;
    SendCommand("RUN", res);
    SendCommand("FOCUS", "NULL");
  }
  const onFinish = () =>
  {
    var res = `player.setBlocks(${count}) \n player.setFinish(true) \n ${code} \n player.RunEvents()`;
    SendCommand("RUN", res);
    SendCommand("FOCUS", "NULL");
  };

  const onFocus = () =>
  {
    console.log("BLUR");
    SendCommand("BLUR", "NULL");
  };
  const onBlur = () =>
  {
    //console.log("FOCUS");
    //SendCommand("FOCUS", "NULL");
  }

  return (
    <>
      <div className="container" onMouseEnter={onFocus} onMouseLeave={onBlur}>
        <BlocklyWorkspace
          style={{ width: '100%', height: '100%' }}
          className="blocks-wrapper"
          initialXml={initial}
          toolboxConfiguration={toolbox}

          workspaceConfiguration={{
            language: 'Hu',
            grid: {
              spacing: 20,
              length: 5,
              colour: "#ccc",
              snap: true,
            },
          }}
          onWorkspaceChange={onChange}
          onXmlChange={setXml}
        />
      </div>
      <div className="controls">
        <Button name="play" desc="play" onTap={onRun} />
        {showFinish && <Button name="finish" desc="finish" onTap={onFinish} />}
      </div>
    </>
  );
};